import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import BrandTierContainer from '../../containers/brand/BrandTierContainer';
import { BRAND_PAGE_NAME } from '../../constants/service/app/brandConstants';

const BrandTier = () => {
  return (
    <PageTemplate pageName={BRAND_PAGE_NAME.BRAND_TIER}>
      <BrandTierContainer />
    </PageTemplate>
  );
};

export default BrandTier;
